module.exports = __webpack_public_path__ + "img/logo5.710b7c18.png";